import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="nf-page">
      <div className="nf-bg-glow nf-glow-1" />
      <div className="nf-bg-glow nf-glow-2" />
      <div className="nf-grid" />

      <div className="nf-content">
        <div className="nf-code">404</div>
        <div className="nf-divider" />
        <h1 className="nf-title">Page Not Found</h1>
        <p className="nf-desc">
          The page you are looking for does not exist or has been moved.<br />
          Let us get you back on track.
        </p>
        <div className="nf-actions">
          <button className="nf-btn-primary" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
            Go Back
          </button>
          <Link to="/" className="nf-btn-outline">Back to Home</Link>
        </div>
        <div className="nf-links">
          <span className="nf-links-label">Quick links:</span>
          {[
            { label: 'Training', path: '/training' },
            { label: 'IT Services', path: '/it-services' },
            { label: 'Enterprise AI', path: '/enterprise-ai' },
            { label: 'Contact', path: '/contact' },
          ].map(l => (
            <Link key={l.path} to={l.path} className="nf-quick-link">{l.label}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}
